import { palette } from './palette';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText,
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .logo-image': {
        height: 46,
      },

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.accordion__collapsable-text': {
    '& .accordion__collapsable-text_anchor': {
      textDecoration: 'none',
    },
    '& .accordion__collapsable-text_code': {
      textDecoration: 'underline',
    },
    '& .accordion__collapsable-text_number': {
      textDecoration: 'underline',
    },
  },

  '.clove-dental-container': {
    paddingTop: 70,
    /* App main - styles */

    '& .affordable': {
      color: palette.primary.main,
      fontWeight: 600,
    },
    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: palette.surface.header,
      '& .section-alternate__content': {
        padding: '48px 16px',
        paddingTop: '85px'
      },
      '& .hero-section-alternate': {
        height: 'auto !important',

        '& .hero-title': {
          fontSize: 42,
          fontWeight: 600,
          lineHeight: '55px',
          maxWidth: 600,
          '@media(max-width: 768px)': {
            fontSize: 48,
            lineHeight: '52px',
          },

          '@media(min-width: 678px)': {
            fontSize: 48,
            lineHeight: '60px',
          },

          '@media(min-width: 900px)': {
            fontSize: '63px',
            lineHeight: '72px',
            letterSpacing: '-0.04em',
          },
          '@media (min-width: 768px) and (max-width: 1023px)': {
            maxWidth: 'none',
            textAlign: 'left',
          },
          '@media(min-width: 900px) and (max-width: 1366px)': {
            fontSize: 52,
            lineHeight: '60px',
          },
        },
        '& .hero-subtitle': {
          fontWeight: 400,
          fontSize: 16,
          lineHeight: '30px',
          maxWidth: 550,
          '@media(min-width: 767px)': {
            fontSize: 18,
          },
          '@media (min-width: 768px) and (max-width: 1800px)': {
            maxWidth: 'none',
            textAlign: 'left',
            maxWidth: 540,
          },
        },
      },
      '& .section-header__title-wrapper': {
        '@media(max-width: 900px)': {
          display: 'flex',
          justifyContent: 'center',
        },
      },
      '& .image-wrapper': {
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
        },
        '@media(max-width: 900px)': {
          display: 'none',
        },
      },
      '@media(min-width: 900px)': {
        maxHeight: '550px',
      },
      '@media(max-width: 900px)': {
        '& .hero-title, .hero-subtitle': {
          textAlign: 'center',
        },
        '& .hero-subtitle': {
          lineHeight: '24px !important',
        },
        '& .section-header__cta-wrapper': {
          '& .section-header__cta-container': {
            '& .section-header__cta-item-wrapper': {
              width: '100%',
              '@media (min-width: 768px) and (max-width: 1800px)': {
                display: 'flex',
              },
            },
          },
        },
      },
      '& .hero-left-section': {
        '@media(max-width: 900px)': {
          padding: '28px',
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      backgroundColor: palette.text.highlight,
      '& .section-alternate__content': {
        padding: '48px 16px',

        '@media (min-width: 600px)': {
          padding: '48px',
        },
        '@media (min-width: 900px)': {
          padding: '72px 48px 80px',
        },
      },
      '& .definition-variant-3': {
        '@media(min-width: 900px)': {
          padding: '80px 60px'
        },
      },
      '& .customRightContainer': {
        display: 'grid',
      },
      '& .customImageWrapper, & .customRightContainer': {
        padding: '28px'
      },
      '& .section-header__title': {
        paddingBottom: '20px !important',
        '@media(max-width: 900px)': {
          paddingBottom: '24px !important',
        },
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
      },
      '& .MuiCardContent-root': {
        padding: 32,
      },
      '& .definition-service-header': {
        marginBottom: 24,
      },
      '& .definition-service-title': {
        fontSize: '24px',
        fontWeight: '600 !important',
        letterSpacing: '-0.32px',
        color: palette.text.tertiary,
      },
      '& .definition-service-description': {
        marginBottom: 0,
        fontSize: '16px',
        fontWeight: 400,
      },
      '& .image': {
        maxHeight: 560,
      },
      '& .definition-service-tile': {
        '@media(max-width: 900px)': {
          paddingBottom: '16px',
        },
      },
    },

    '& .subscription-wrapper': {
      background: palette.background.main,
      '& .section-alternate': {
        padding: '26px 16px',
      },
      '& .subscription-section': {
        padding: '36px 56px',
        minHeight: '300px !important',
        '@media(max-width: 900px)': {
          padding: '36px 12px',
        },
        '& .getstarted-button-desktop': {
          height: '56px',
          width: '132px',
          fontSize: '18px',
          letterSpacing: '-0.72px'
        },
        '& .subscription-section-container': {
          '& .left-section': {
            '& .review-box': {
              '@media(max-width: 900px)': {
                '& .review': {
                  paddingTop: '12px !important',
                  marginTop: '0px !important',
                  marginBottom: '16px !important',
                },
                marginBottom: '16px !important',
              },
              '@media(min-width: 900px)': {
                '& .review': {
                  fontSize: '24px !important',
                  marginTop: '16px',
                  marginBottom: '32px',
                  color: palette.text.highlight,
                },
              },
            },
            justifyContent: 'center',
            '& .title-box': {
              '& .section-header__title': {
                color: palette.text.highlight,
                maxWidth: 640,
              },
              '& .section-header__subtitle': {
                color: palette.text.highlight,
                fontSize: '24px',
                maxWidth: 650,
                lineHeight: '26px',
                fontWeight: 100,
                '@media(max-width: 900px)': {
                  fontSize: '18px',
                },
              },
              marginBottom: '0px !important',
            },
            '& .savings-link': {
              marginTop: '24px',
            },
            '@media(max-width: 900px)': {
              '& .description-section': {
                marginTop: '32px',
                width: '100%',
              },
            },
            '& .getstarted-button': {
              backgroundColor: palette.text.highlight,
              color: palette.text.primary,
              height: 64,
              width: 170,
              '&:hover': {
                backgroundColor: palette.text.highlight,
                color: palette.text.primary,
              },
            },
            '& .savings-summary-link': {
              color: palette.text.highlight,
              textDecoration: 'underline',
            },
            '& .getstarted-button-container': {
              padding: '0px !important',
              paddingBottom: '48px !important',
              '@media(max-width: 900px)': {
                paddingBottom: '8px !important',
              },
            },
          },
          '& .right-section': {
            '& .planCard': {
              '& .price-item': {
                backgroundColor: palette.surface.gray,
                marginBottom: '0px !important',
                padding: '16px 16px',
              },
              '& .customPlanDescription, .cardDivider': {
                display: 'none',
              },
              '& .cptCodes': {
                fontSize: '18px',
              },
              '& .customTieredPlans': {
                minHeight: '0px !important',
              },
              '& .planCard': {
                backgroundColor: palette.text.primary,
              },
              '& .customBenefitsContainer': {
                minHeight: '0px !important',
                marginBottom: '0px !important',
              },
              '& .customUpfrontWrapper': {
                textAlign: 'left',
                marginTop: '18px',
                paddingLeft: '32px',
                paddingBottom: '40px',
              },
              '& .cardDivider': {
                paddingTop: 0,
                margunBottom: 12,
              },
              '&:hover': {
                color: palette.text.primary,
                backgroundColor: palette.text.highlight,
              },
              '@media(max-width: 900px)': {
                '& .customCardContent': {
                  paddingLeft: '16px',
                  paddingRight: '16px',
                },
              },
            },
            '& .plans-loader': {
              color: palette.text.highlight,
            },
          },
          '& .desc-box': {
            '& .savings-summary-link': {
              color: palette.text.alternate,
            },
            '& .customMetricsDescription': {
              color: palette.text.highlight,
              fontWeight: 400,
            },
            '@media(max-width: 900px)': {
              marginTop: '20px',
            }
          },
          '& savings-link': {
            color: palette.text.alternate,
          },
        },
        '@media(min-width: 900px) and (max-width: 1366px)': {
          padding: '80px 30px',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.surface.gray,

      '& .working-steps-main-container': {
        paddingBottom: '24px !important',
      },

      '& .section-header__subtitle': {
        fontSize: '24px',
        color: '#383838',
      },

      '@media(min-width: 900px) and (max-width: 1365px)': {
        '& .section-header__subtitle': {
          fontSize: '20px',
        }
      },
      '@media(max-width: 900px)': {
        '& .section-header__subtitle': {
          lineHeight: '28px',
        }
      },

      '& .section-header__title': {
        color: '#383838',
      },

      '& .section': {
        '@media(min-width: 900px)': {
          padding: '53px 40px'
        },
      },

      '& .howitworks-title': {
        marginBottom: 6,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .how-cover-image': {
        backgroundSize: 'cover',
        height: '100%',
        maxHeight: '544px'
      },
      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
        height: '32px',
        width: '32px',
        fontSize: '12.5px',
      },
      '& .step-content': {
        maxWidth: 500,
      },
      '& .step-title': {
        lineHeight: '24px',
      },
      '& .step-started-button': {
        padding: '18px 24px',
        minWidth: 100,
        '& .right-icon': {
          display: 'none',
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 20,
        position: 'relative',
        '@media(max-width:900px)': {
          borderBottom: `1px solid ${palette.text.disabled}`,
        },
        '@media(min-width: 900px)': {
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            width: '80%',
            height: '1px',
            backgroundColor: palette.text.disabled,
            // Tablet responsive
            '@media screen and (max-width: 1024px)': {
              left: '20%',
              width: '70%',
            },
            // Mobile responsive
            '@media screen and (max-width: 768px)': {
              left: '15%',
              width: '80%',
            },
            // Small mobile responsive
            '@media screen and (max-width: 480px)': {
              left: '5%',
              width: '90%',
            },
          },
        },
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
        '& .cover-image-wrapper': {
          padding: '0px',
          paddingBottom: '16px',
        }
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-title': {
        color: palette.text.primary,
        fontSize: '32px',
        fontWeight: '600',
        lineHeight: '40px',
      },
      '& .hero-static-subtitle': {
        fontSize: '24px',
        fontWeight: '400',
        color: palette.text.secondary,
      },
      '& .hero-static-bg': {
        background: palette.text.highlight,
      },
      '& .hero-static-section': {
        '& .section-alternate__content': {
          paddingBottom: 46,
          paddingTop: 46,
          '@media(min-width:900px)': {
            paddingLeft: 0,
            paddingRight: 0,
          },
        },
        '@media(min-width:1600px)': {
          padding: '0px 48px'
        },
        '@media(min-width:1400px)': {
          padding: '0px 64px'
        },
        '@media(min-width:1500px)': {
          padding: '0px 48px'
        },
      },
      '& .primary-static-button': {
        background: palette.primary.main,
        border: `1px solid ${palette.text.primary}`,
        color: palette.text.highlight,
        padding: '18px 24px',
      },
      '& .hero-button-wrapper': {
        '@media(min-width:900px)': {
          justifyContent: 'flex-end'
        }
      }
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table .savings-subheader': {
        backgroundColor: palette.background.main,
        fontWeight: 600,
      },
      '& .savings-contact-card': {
        backgroundColor: palette.background.main,
      },
      '& .savings-header': {
        color: palette.text.primary,
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, & .faq-hero-section, & .find-provider-section, & .checkout-hero-section':
    {
      backgroundColor: palette.background.main,
      '& .hero-home-button': {
        borderColor: palette.text.highlight,
        color: palette.text.highlight,
      },
      '& .hero-header-title, & .hero-header-subtitle': {
        color: palette.text.highlight,
      },
    },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,

      '& .MuiTypography-root': {
        color: palette.text.primary,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .find-provider-section, & .plan-selection-section': {
        background: palette.background.main,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          color: palette.text.primary,
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .hero-static-section': {
          '& .section-header__title': {
            color: palette.text.primary,
          },
        },
        '& .hero-static-bg': {
          backgroundColor: palette.background.main,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .view-more-button': {
        background: palette.primary.main,
        color: palette.text.highlight,
      },
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
          fontWeight: 'unset',
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 60px !important',
        backgroundColor: palette.surface.grey,
      },

      '& .footer-bar-text': {
        color: palette.text.highlight,
      },
      '& .footer-bar': {
        background: palette.background.main,
      },
    },

    /* FAQ */
    '& .faq-contact-wrapper, & .savings-contact-card': {
      background: palette.background.footer,
    },
    '& .faq-hero-section': {
      '& .hero-link-button': {
        background: palette.text.highlight,
        color: palette.text.primary,
      },
    },
    '& .faq-contact-section': {
      background: palette.surface.grey,
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
    },
    /* Footer */
    '& .footer-wrapper, & .footer-wrapper a': {
      backgroundColor: palette.text.highlight,
      color: palette.text.primary,
      '& .MuiGrid-item': {
        '@media(min-width: 900px)': {
          padding: '16px 8px'
        },
        '@media(max-width: 900px)': {
          padding: '20px'
        },
        '@media(min-width: 1400px)': {
          padding: '16px 28px'
        },
      }
    },
  },
}